import { render, staticRenderFns } from "./postTransactionTransactionList.vue?vue&type=template&id=634a301e"
import script from "./postTransactionTransactionList.vue?vue&type=script&lang=js"
export * from "./postTransactionTransactionList.vue?vue&type=script&lang=js"
import style0 from "./postTransactionTransactionList.vue?vue&type=style&index=0&id=634a301e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports